import React, {createContext, useContext, useEffect, useState} from "react";
import {io} from "socket.io-client";
import {useAuth} from "../../authprovider";
import packageJson from '../../../package.json';

const socketContext = createContext();

export function useSocket(){
    return useContext(socketContext)
}

export const SOCKET_EVENT = {
    ON_CONNECTED:"connect",
    DURING_CALL:"isDuringCall",
    ON_OFFER:"offer",
    ACCEPT_OFFER:"answer",
    GET_MESSAGES:"getMessages",
    SEND_MESSAGE:"message",
    UPDATE_CHAT:"updateChat",
    END_CALL:"endCall",
    ERROR:"connect_error",
    DISCONNECT :"disconnect",
    ON_PUSH:"onPush"
}

export default function ProvideSocket(props) {

    const auth = useAuth();
    const provideSocket = useProvideSocket(auth.user, props.hash);

    useEffect(()=>{

        provideSocket.socket.on(SOCKET_EVENT.ON_CONNECTED, ()=>{
            console.log("socket connected")
        })
        provideSocket.socket.on(SOCKET_EVENT.DISCONNECT, (reason) => {
            console.log(reason)
        });

        provideSocket.socket.on(SOCKET_EVENT.ERROR, (error) => {
            console.error("Error", error)
        });
        console.log("ProvideSocket->useEffect")
        //todo: make connection and disconnect
        return function cleanup(){
            provideSocket.socket.disconnect()
        }
    })

    return (
        <socketContext.Provider value={provideSocket}>
            {props.children}
        </socketContext.Provider>
    );
}

function getSocket(jwt, id){
    const port = packageJson.development ? "3006":"80";
    return io("ws://"+window.location.hostname+":"+port+"/",{
        reconnectionDelayMax: 5000,
        withCredentials: true,
        extraHeaders: {
            "x-auth-token": jwt,
            "building-id":id
        }
    });
}

function useProvideSocket(user, building_id) {
    const [socket] = useState(()=> getSocket(user.token, building_id) );
    const messageHanlders = [];

    socket.on(SOCKET_EVENT.UPDATE_CHAT, (message)=>{
        console.log("received messsage => "+message);
        const msg = JSON.parse(message);
        msg.received = true;

        const handler = messageHanlders.find((v)=> v.id === msg.call_id);

        if(handler)
            handler.callback(msg);
    })


    const registerMessageHandler = (callId,callback)=>{
        messageHanlders.push({id:callId, callback:callback})
    }

    const unregisterMessageHandler = (callId)=>{
        const index = messageHanlders.findIndex((h)=>h.id === callId);

        if(index<0)
            return;

        messageHanlders.splice(index, 1);
    }

    return {
        socket,
        registerMessageHandler,
        unregisterMessageHandler
    };
}